import { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import SideNav from "./components/SideNav";

const ApplicationLayout = () => {
  const { i18n } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleOpenMobileNav = () => setMobileOpen(true);
  const handleCloseMobileNav = () => setMobileOpen(false);

  return (
    <Box sx={styles.container}>
      <NavBar onOpenMobileNav={handleOpenMobileNav} />
      <Box sx={styles.content}>
        <SideNav mobileOpen={mobileOpen} handleCloseMobileNav={handleCloseMobileNav} />
        <Box sx={styles.main} component="main">
          <Outlet />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default ApplicationLayout;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
  },
  content: {
    display: "flex",
    gap: "15px",
    maxWidth: "1140px",
    margin: { xs: "0 15px", md: "0 30px", lg: "0 auto" },
    background: "#F7F8F8",
    flex: 1,
    mb: { xs: "0", lg: "35px" },
    minHeight: { xs: "calc(100dvh - 126px)", lg: "calc(100dvh - 91px)" },
  },
  main: {
    flex: 1,
    width: { xs: "100%", lg: "870px" },
  },
};
